import React from 'react';
import store from "../../../../../../store";

import {
  openModalFix,
  setNextDisabledForCurrentStepModalFix,
  updateFeatureIdModalFix
} from "../../../../../../actions/sqftModalFunctions";
import {
  clearCacheForTheEdgeFeatures,
  setSQFTActiveButton,
  setSQFTMenuOpened
} from "../../../../../../actions/sqftMenuFunctions";
import {
  BACKSPLASH_LABELS,
  EDGE_LABELS,
  PART_IDS_THAT_CAN_BE_CHANGED_IN_SQFT,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SQFT_FEATURES,
} from "../../../../constants";
import {getCurrentLayout} from "../../../../../appLayout";
//import {getFeatureGroupName} from "../../../../../../misc/helpers";
//import workspace from "../../../canvas/core/workspace";
import {enableSquareFootage, setSQFTInVisualizer} from "../../../../../../actions/sqftFunctions";
import {
  getNextWizardSteps,
  getWizardGroupName
} from "../../../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import workspace from "../../../canvas/core/workspace";
import workspaceZoom from "../../../canvas/core/workspaceZoom";
import {getShapesCenter} from "../../../../helpers/conflictPopupHelper";
import sqftConfig from "../../../canvas/store/sqftConfig";
import {
  changeCartFeature,
  removeManyFromCart,
  toggleSelectionFeatureInfo
} from "../../../../../../actions/actionFunctions";
import sqftShapeManager from "../../../canvas/store/sqftShapeManager";
import {prepareSQFTDataCore} from "../../../canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../../../helpers/sqftQuotesHelper";
import {fetchFeatures} from "../../../../hocs/useFetchFeatures";
import CommonCompatibilityUpdateWarning from "./CommonCompatibilityUpdateWarning";
import CommonCompatibilityRemoveWarning from "./CommonCompatibilityRemoveWarning";
import {removeFromSqftCalcData} from "../../../../helpers/sqFtCalcDataHelper";
import {setWizardConflictSteps, setWizardSelectedValues} from "../../../../../../actions/wizardFunctions";
import {changeAllCartItems} from "../../../../../../actions/shoppingCartFunctions";
import * as types from "../../../../../../actions/actionTypes";
import {getFeatureGroupName} from "../../../../../../misc/helpers";
import {getWizardPropertiesForFeature} from "../../../canvas/core/controls/resourseCanas";
import {updateNavigationCount} from "../../../../../../actions/lookFunctions";
import {enableRegularMode, enableSlabMode} from "../../../canvas/store/canvasHelper";
import {showSlabTool} from "../../../../../../actions/sqftSlabFunctions";
import {setSQFTCartItemsToAdd} from "../../../../../../actions/sqftResourceFunctions";
import {categorizeConflictingCartItemsFromStore} from "../../../../../popups/wizardConflictPopup/steps/conflictPopupHelper";
import {getNextNotCheckedStep} from "../../../../../qkbPages/materialsWizard/useChangeWizardStepRoute";

export const handleOpenModalFix = async (props) => {
  const {changeWizardStepRoute, intl} = props;
  const state = store.getState();
  const { wizardActiveItem, wizardActiveStep, wizardSelectedValues } = state.wizardState;
  const { selectionFeatureInfo } = state.selectionState;
  const {isModalFixOpen} = state.sqftModalFixState;
  const {isSquareFootageEnabled} = state.sqftState;
  const fabricatorData = state.fabricatorState;

  const layout = getCurrentLayout();

  // Categorize conflicting items using wrapper
  const { itemsToRemove, itemsToUpdate, itemsToUpdateGrouped } = categorizeConflictingCartItemsFromStore();

  console.log('Items to remove:', itemsToRemove);
  console.log('Items to update:', itemsToUpdate);
  console.log('Items to itemsToUpdateGrouped:', itemsToUpdateGrouped);

  if ((itemsToRemove.length > 0 || itemsToUpdate.length > 0) && !isModalFixOpen) {
    // Remove incompatible items
    const cartItemIdsToRemove = itemsToRemove.map(item => item.cartItem.id);
    deleteIncompatibleCartItems(cartItemIdsToRemove);

    // Create steps for items that need updating
    const steps = [];

    const wizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

    for (const group  of itemsToUpdateGrouped) {
      const itemData = group.representative;
      const { cartItem, wizardConflictingStep } = itemData;
      const cartItemIds = group.cartItemIds;

      const partId = cartItem.partId;
      const featureGroup = layout.getFeatureGroupByPartId(partId);

      const wizardGroup = wizardActiveItem.wizardGroups.find(wizGroup => {
        return wizGroup.id === wizardConflictingStep.wizardGroupId
      });

      if (!wizardGroup) {
        console.error('wizardGroup was not found for the wizardConflictingStep');
        continue;
      }

      const wizardGroupName = getWizardGroupName(wizardGroup);
      const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
      const groupName = wizardGroupName || featureGroupName;
      const buttonName = getButtonNameForPartId(partId);
      const featuresData = await fetchFeatures([partId], '', {}, true);

      let sameNewWizardStep = wizardSteps.find(step => step.stepIndex === wizardConflictingStep.stepIndex);
      if (!sameNewWizardStep || sameNewWizardStep.stepGroups?.[0]?.groupName !== wizardGroup.groupName) {
        sameNewWizardStep = wizardSteps.find(step => step.stepGroups?.[0]?.groupName === wizardGroup.groupName)
      }
      const isSQFTStep = cartItem.sqftId && PART_IDS_THAT_CAN_BE_CHANGED_IN_SQFT.includes(partId);
      const isSQFTInVisualizerStep = cartItem.sqftId || Array.isArray(cartItem.sqftIds);

      const title = intl.formatMessage({id: "modalFix.title.update"}, {groupName});

      // Tiny helper: avoid repeating the same zoom timeout block
      const zoomToShapesCenter = () => {
        setTimeout(() => {
          const shapes = workspace.getShapesWithoutAttachedResources();
          const centerPoint = getShapesCenter(shapes);
          workspaceZoom.zoomTo(centerPoint, 0.1);
        }, 700);
      };

      // Factory: returns the onStepEnter handler for a given targetStepIndex
      const makeOnStepEnter = (targetStepIndex) => (stepData) => {
        if (isSQFTStep) {
          store.dispatch(enableSquareFootage(true));
          store.dispatch(setSQFTInVisualizer(false));

          if (stepData.isSQFTStep && featuresData[partId]?.rows?.length > 0) {
            store.dispatch(setSQFTMenuOpened(buttonName));
            store.dispatch(setSQFTActiveButton(buttonName));
            enableRegularMode();
            store.dispatch(showSlabTool(false));
          }

          zoomToShapesCenter();
          return;
        }

        // Non-SQFT step enter
        store.dispatch(enableSquareFootage(isSQFTInVisualizerStep));
        if (selectionFeatureInfo) {
          store.dispatch(toggleSelectionFeatureInfo(null));
        }

        store.dispatch(updateNavigationCount());
        store.dispatch(setSQFTInVisualizer(true));

        if (changeWizardStepRoute) {
          changeWizardStepRoute(targetStepIndex, wizardActiveItem, wizardSteps);
        }

        sqftConfig.setScale(2.5);
        zoomToShapesCenter();
      };

      const onStepExit = () => {
        store.dispatch(setSQFTMenuOpened(''));
        store.dispatch(setSQFTActiveButton(''));
      };

      const newStep = {
        id: 'incompatibleCartItems',
        title,
        content: getContentForFeatureGroup(featureGroup, groupName, false),
        partId: cartItem.partId,
        featureId: cartItem.cartFeature.dbFeature.id,
        featureName: cartItem.cartFeature.getFeatureName(),
        isSQFTStep,
        params: {
          shouldRemove: false,
          cartItemIds: cartItemIds,
          stepIndex: sameNewWizardStep.stepIndex,
        },
        showClose: false,
        showCancel: true,
        showSkip: false,
        skipButtonText: 'Skip',
        isNextButtonDisabled: true,
        enterAnim: 'fadeDown',
        exitAnim: 'fadeUp',
        onStepEnter: makeOnStepEnter(sameNewWizardStep.stepIndex),
        onStepExit,
      };

      // 1) add prev step if it is the same group and requires to select style (renuit issue)
      const prevTargetStepIndex = sameNewWizardStep.stepIndex - 1;
      const prevWizardStep = wizardSteps.find(step => step.stepIndex === prevTargetStepIndex);
      const prevGroup = prevWizardStep?.stepGroups?.[0];

      const shouldAddPrevStyleStep =
        !!sameNewWizardStep
        && !!prevWizardStep
        && !!prevGroup?.hidePriceNoCart
        && prevGroup?.groupName === wizardGroup.groupName;

      if (
        shouldAddPrevStyleStep
        && !steps.some((step) => step?.params?.stepIndex === prevTargetStepIndex)
      ) {
        steps.push({
          ...newStep,
          params: {
            ...newStep.params,
            isAssistingStep: true,
            cartItemIds: [],
            stepIndex: prevTargetStepIndex,
          },
          onStepEnter: makeOnStepEnter(prevTargetStepIndex),
        });
      }

      // 2) push original step
      steps.push(newStep);
    }

    const jumpToStepAfterFinish = getNextNotCheckedStep(true);
    const isSQFTEnabledSnapshot = !!state.sqftState?.isSquareFootageEnabled;

    // 3) add prev/next for each step
    steps.forEach((step, idx) => {
      const isFirst = idx === 0;
      const isLast = idx === steps.length - 1;

      step.showPrev = !isFirst;
      step.nextButtonText = isLast ? 'Finish' : 'Next';
      if (isLast) {
        const prevOnStepExit = step.onStepExit;
        step.onStepExit = (...args) => {
          if (typeof prevOnStepExit === 'function') { // keep existing behavior
            prevOnStepExit(...args);
          }
          let currentWizardSelectedValues = store.getState().wizardState.wizardSelectedValues;
          Object.keys(currentWizardSelectedValues).forEach(key => {
            if (currentWizardSelectedValues[key].isAutoSkippedStep) {
              delete currentWizardSelectedValues[key]
            }
          });
          store.dispatch(setWizardSelectedValues(currentWizardSelectedValues, true)); // update allWizardSelectedValues in the end
          if (itemsToUpdate.length && !isSQFTEnabledSnapshot) {
            changeWizardStepRoute(jumpToStepAfterFinish, wizardActiveItem);
          }
        };
      }
    });

    console.log('steps', steps);
    console.log('cartItemIdsToRemove', cartItemIdsToRemove);

    if (!isModalFixOpen && steps.length > 0) {
      store.dispatch(openModalFix('incompatibleCartItems', steps, () => {
        console.log('Modal completed - user updated edge style');

        store.dispatch(setSQFTInVisualizer(false));
        store.dispatch(setWizardConflictSteps([]));
        store.dispatch(setSQFTCartItemsToAdd([]));

        sqftConfig.initializeDependentProperties();
        if (isSquareFootageEnabled) {
          setTimeout(() => {
            let centerPoint = getShapesCenter(workspace.getShapesWithoutAttachedResources());
            workspaceZoom.zoomTo(centerPoint, 0.1);
          }, 700);
        }
      }));
    }

    store.dispatch(setWizardSelectedValues({
      [wizardActiveStep]: wizardSelectedValues[wizardActiveStep]
    })); // passed already selected value to update conflicting steps
  }
};

const getContentForFeatureGroup = (featureGroup, featureGroupName, shouldRemove) => {
  if (shouldRemove) {
    return React.createElement(CommonCompatibilityRemoveWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName
    });
  } else {
    return React.createElement(CommonCompatibilityUpdateWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName
    });
  }
}

const getButtonNameForPartId = (partId) => {
  if (Object.keys(EDGE_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.edge
  } else if (Object.keys(BACKSPLASH_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.backsplash
  } else if (SQFT_FEATURES.crown_molding === partId) {
    return SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding
  } else if (SQFT_FEATURES.radius === partId) {
    return SIDEBAR_NAVIGATION_BUTTONS.radius
  }
}

export const deleteIncompatibleCartItems = (cartItemIds) => {
  const cartItemIdsToRemove = [];
  const state = store.getState();
  const {quotes, activeQuoteIndex} = state.quotesState;
  const currentQuote = quotes[activeQuoteIndex];
  const cartItems = state.cartState.cartItems;
  const sqftCartItems = state.sqftResourceState.sqftCartItems;
  const cartItemsAndSQFTTempCartItems = [...cartItems, ...sqftCartItems];
  const sqftIdsToRemove = [];
  for (const cartItemId of cartItemIds) {
    cartItemIdsToRemove.push(cartItemId);
    const cartItem = cartItemsAndSQFTTempCartItems.find(cartItem => cartItem.id === cartItemId);

    //remove sqft items
    if (cartItem && cartItem.sqftId) {
      workspace.removeFeatureBySQFTId(cartItem.sqftId);
      sqftIdsToRemove.push(cartItem.sqftId);
    }

    if (cartItem && cartItem.sqftIds && cartItem.sqftIds.length) {
      for (const sqftId of cartItem.sqftIds) {
        workspace.removeFeatureBySQFTId(sqftId);
        sqftIdsToRemove.push(sqftId);
      }
    }
  }
  removeFromSqftCalcData(currentQuote, sqftIdsToRemove);
  store.dispatch(removeManyFromCart(cartItemIdsToRemove));
}

/**
 * Change cart item + feature in sqft
 */
export const fixFeature = async (currentFeature, passedWizardProps) => {
  const state = store.getState();
  const { sqftModalFixState, cartState } = state;

  if (!sqftModalFixState.isModalFixOpen) {
    return;
  }

  const cartItems = cartState.cartItems;
  const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
  const cartItemIds = currentStepData?.params?.cartItemIds || [];
  const isAssistingStep = currentStepData?.params?.isAssistingStep;

  if (isAssistingStep) {
    store.dispatch(setNextDisabledForCurrentStepModalFix(false));
    return;
  }

  if (!cartItemIds.length) {
    console.error('fixFeature: cartItemIds is empty');
    return;
  }

  const cartItemIdsSet = new Set(cartItemIds);
  const firstCartItem = cartItems.find(item => cartItemIdsSet.has(item.id));

  const incompatibleFeatureId = firstCartItem.cartFeature?.dbFeature?.id;
  const wizardProps = passedWizardProps || getWizardPropertiesForFeature(currentFeature);
  const {fromWizardId, fromWizardStep, fromWizardGroupId} = wizardProps;

  // Update cart items
  for (const cartItem of cartItems) {

    if (!cartItemIdsSet.has(cartItem.id)) {
      continue;
    }

    const newItem = {
      ...cartItem,
      cartFeature: currentFeature,
      fromWizardId,
      fromWizardStep,
      fromWizardGroupId
    };

    store.dispatch(changeCartFeature(newItem));
  }

  // Update shapes with incompatible feature
  const incompatibleShapes = workspace.getShapesByFeatureId(incompatibleFeatureId);
  for (const shape of incompatibleShapes) {
    sqftShapeManager.setShapeFeature(shape.id, currentFeature);
  }

  // Update parent feature shapes
  const incompatibleParentShapes = workspace.getShapesByParentFeatureId(incompatibleFeatureId);
  for (const shape of incompatibleParentShapes) {
    sqftShapeManager.setShapeRelatedParentFeatureId(shape.id, currentFeature.dbFeature.id, currentFeature.partId);
  }

  sqftShapeManager.updateShapesWizardProperties();

  // Save quote
  const coreData = prepareSQFTDataCore();
  await saveSQFTDataToQuote(coreData);

  // Update modal state
  store.dispatch(updateFeatureIdModalFix(currentFeature.dbFeature.id, currentFeature.getFeatureName()));
  store.dispatch(setNextDisabledForCurrentStepModalFix(false));
  store.dispatch(clearCacheForTheEdgeFeatures());
};

/**
 * Create a snapshot of current state before making changes
 * (cartItems, sqftCalcData, wizardSelectedValues)
 */
export const createModalFixSnapshot = () => {
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  const wizardSelectedValues = state.wizardState.wizardSelectedValues;

  // Get SQFT data without images (fast)
  const sqftCalcData = prepareSQFTDataCore();

  return {
    cartItems: cartItems,
    wizardSelectedValues: wizardSelectedValues,
    sqftCalcData: sqftCalcData,
    timestamp: Date.now()
  };
};

/**
 * Restore state from snapshot
 */
export const restoreFromSnapshot = async (snapshot) => {
  if (!snapshot) {
    console.warn('No snapshot to restore');
    return;
  }

  console.log('Restoring from snapshot', snapshot);
  const state = store.getState()
  const isShowSlabTool = state.sqftSlabState.isShowSlabTool;

  // 1. Restore cart items
  const cartItems = [...snapshot.cartItems];
  store.dispatch(changeAllCartItems(cartItems));

  // 2. Restore workspace state
  if (snapshot.sqftCalcData) {
    workspace.import(snapshot.sqftCalcData);
  }

  // 3. Update quotes with restored data
  /** data without images */
  const coreData = prepareSQFTDataCore();
  await saveSQFTDataToQuote(coreData);

  // 4. Restore wizard selected values
  store.dispatch({
    type: types.SET_WIZARD_SELECTED_VALUES,
    payload: {
      //wizardSelectedValues: state.wizardState.beforeConflictSelectedValues ?? state.wizardState.wizardSelectedValues,
      wizardSelectedValues: {...snapshot.wizardSelectedValues},
      wizardConflictingSteps: [],
    }
  })

  // 5.) Switch tore enable slab mode
  if (isShowSlabTool) {
    enableSlabMode();
    store.dispatch(showSlabTool(true));
  }

  console.log('Snapshot restored successfully');
};
